var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { I18nextProvider } from 'react-i18next';
import { QueryClientProvider, useQueryClient } from '@tanstack/react-query';
import PreferenceCenter from './pages/PreferenceCenter';
import SyfAlerts from './pages/SyfAlerts';
import { theme } from './theme';
import alertsI18n from './strings/i18n/i18n';
import SyfStorage from './helpers/SyfStorage';
import queryClient from './const/queryClient';
var MFEWrapper = function (_a) {
    var children = _a.children;
    useEffect(function () {
        alertsI18n.changeLanguage(SyfStorage.getLanguage());
    }, []);
    var isQueryClientPresent = useQueryClient();
    var dynamicMfeRenderer = (_jsx(I18nextProvider, __assign({ i18n: alertsI18n }, { children: children })));
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: isQueryClientPresent ? (dynamicMfeRenderer) : (_jsx(QueryClientProvider, __assign({ client: queryClient }, { children: dynamicMfeRenderer }))) })));
};
var ThemedAlerts = function (_a) {
    var platform = _a.platform, alertType = _a.alertType, config = _a.config, handleProfileClick = _a.handleProfileClick, accountSummaryKeys = _a.accountSummaryKeys;
    return (_jsx(MFEWrapper, { children: _jsx(SyfAlerts, { platform: platform, alertType: alertType, config: config, handleProfileClick: handleProfileClick, accountSummaryKeys: accountSummaryKeys }) }));
};
export var PreferenceSettings = function (_a) {
    var platform = _a.platform, config = _a.config, handleProfileClick = _a.handleProfileClick;
    return (_jsx(MFEWrapper, { children: _jsx(PreferenceCenter, { platform: platform, config: config, handleProfileClick: handleProfileClick }) }));
};
export default ThemedAlerts;
